<template>
  <div>
    <div v-if="mode === 'DESIGN'" class="my-date-range-picker disabled-box max-width">
      <el-date-picker size="small" v-model="_value"  :type="type" :start-placeholder="placeholder[0]" :end-placeholder="placeholder[1]"  :default-time="['00:00:00', '23:59:59']"  prefix-icon="el-icon-date"/>
      <!-- <div v-if="showLength" class="length">
        <span>时长：</span>
        <span>{{timeLength}}</span>
      </div> -->
      <div v-if="totalType=='day' || totalType=='hour'" class="total-time-con">
        <span class="text">累计时间：</span>
        <span class="time">{{ totalTime }}</span>
      </div>
    </div>
    <div v-else>
      <template>
        <div  v-if="!readerMode || perm==='E'" class="my-date-range-picker">
          <el-date-picker v-model="_value" size="small" clearable :value-format="format" :type="type" :disabled="perm==='R'" :start-placeholder="placeholder[0]" :end-placeholder="placeholder[1]"  prefix-icon="el-icon-date" :default-time="['00:00:00', '23:59:59']"/>
        </div>
        <div v-else class="form-item-text">
          <template v-if="value.length==2">
            {{ value[0] + ' ~ ' + value[1] }}
          </template>
        </div>
        <!-- <el-date-picker v-else v-model="_value" size="small" clearable :value-format="format" :type="type" :start-placeholder="placeholder[0]" :end-placeholder="placeholder[1]" disabled  prefix-icon="el-icon-date" :default-time="['00:00:00', '23:59:59']"/> -->
      </template>
      <div v-if="totalType=='day' || totalType=='hour'" class="total-time-con">
        <span class="text">累计时间：</span>
        <span class="time">{{ totalTime }}</span>
      </div>
      <!-- <div v-if="showLength" class="length">
        <span>时长：</span>
        <span>{{timeLength}}</span>
      </div> -->
    </div>
  </div>
</template>

<script>
import componentMinxins from '../ComponentMinxins'
import moment from 'moment';

export default {
  mixins: [componentMinxins],
  name: "DateTimeRange",
  components: {},
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    format:{
      type: String,
      default: 'yyyy-MM-dd'
    },
    placeholder:{
      type: Array,
      default: ()=>{
        return ['开始时间', '结束时间']
      }
    },
    showLength:{
      type: Boolean,
      default: false,
    },
    readerMode: {
      type: Boolean,
      default: false,
    },
    totalType: {
      type: String,
      default: 'none' // 'day' 或 'hour'
    }
  },
  computed: {
    type(){
      switch (this.format){
        case 'yyyy-MM-dd': return 'daterange';
        case 'yyyy-MM-dd HH:mm:ss': return 'datetimerange';
        default: return 'datetimerange';
      }
    },
    timeLength(){
      //求时长算法
      if (Array.isArray(this.value)){
        let start = moment(this.value[0]).format(this.format.replaceAll('dd', 'DD'))
        let end = moment(this.value[1]).format(this.format.replaceAll('dd', 'DD'))
        if (start === end){
          return '0 （时长为0，请确认）'
        }
        let mstart = moment(start);
        let mend = moment(end)
        let years = mend.diff(start, 'years')
        let months = mend.diff(start, 'months')
        let days = mend.diff(start, 'days')
        let hours = mend.diff(start, 'hours')
        let minutes = mend.diff(start, 'minutes')
        minutes = minutes % 60
        hours = hours % 24
        months = months % 12 
        //因为每月天不固定，所以天要特殊动态处理
        if(mstart.date() < mend.date()){
          days = mend.date() - mstart.date()
          if (minutes > 0 || hours > 0){
            days --;
          }
        }
        //处理超过俩月且天超过31
        if (days > 31 && mend.month() - mstart.month() >= 2){
          //将日期推至上月求差
          days = mend.diff(mstart.add(mend.month() - mstart.month() - 1, 'month'), 'days')
        }
        return `${years > 0 ? years + '年 ': ' '}${months > 0 ? months + '个月 ': ' '}
                ${days > 0 ? days + '天 ': ' '}${hours > 0 ? hours + '小时 ': ' '}
                ${minutes > 0 ? minutes + '分钟 ': ' '}`
      } else {
        return '先选择时间哦'
      }
    },
    // 累计时间
    totalTime(){
      if (Array.isArray(this.value)){
        let start = this.value[0]
        let end = this.value[1]
        
        
        let unit = ''
         if (this.totalType === 'day') {
            unit = ' 天'
         }else if (this.totalType === 'hour') {
            unit = ' 小时'
         }
        if (!start || !end) return 0 + unit;
        if(this.format=='yyyy-MM-dd'){
          start += ' 00:00:00'
          end += ' 23:59:59'
        }
        //  console.log('>>',start, end)  
        const startTime = new Date(start).getTime();
        const endTime = new Date(end).getTime();
        const diffInMs = endTime - startTime;
        // console.log('>>',startTime, endTime,diffInMs)  
        if (this.totalType === 'day') {
          // 计算天数差并向上取整
          return Math.ceil(diffInMs / (1000 * 60 * 60 * 24)) + unit;
        } else if (this.totalType === 'hour') {
          // 计算小时差并向上取整
          return Math.ceil(diffInMs / (1000 * 60 * 60)) + unit;
        }
        return 0 + unit;
      }
    },
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped lang="scss">
.max-width{
  max-width: 320px;
}
.my-date-range-picker {
  position: relative;
  line-height: 1;
  display: inline-block;
  /deep/{
    .el-input__inner{
      padding: 0 0 0 8px;
      // width: 320px;
      width: 100%;
      max-width: 320px;
      }
    .el-range-separator{
      padding: 0;
      line-height: 26px;
    }
    .el-date-editor .el-range__icon{
      position: absolute;
      margin: 0;
      float: none;
      top: 0;
      right: 5px;
      height: 32px;
      font-size: 13px;
      line-height: 32px;
      
    }
    .el-date-editor .el-range__close-icon{
      position: absolute;
      top: 0;
      float: none;
      right: 25px;
      transition: none;
      font-size: 13px;
      line-height: 32px;
    }
  }
}
.w-220{
  width: 220px;
}
/* .length{
  margin-top: 5px;
}
.length:nth-child(2){
  color: #8c8c8c;
} */
/* /deep/ .el-range-editor.el-input__inner{
  width: 100%;
  max-width: 360px;
} */
 .total-time-con{
  padding-top: 6px;
  line-height: 1;
  // color: #2F3030;
  .text{
    color: #939696;
  }
  .time{
    color: #2F3030;
  }
}
</style>
